import { render } from "./localizedInput.vue?vue&type=template&id=6300d236&scoped=true&ts=true"
import script from "./localizedInput.vue?vue&type=script&lang=ts"
export * from "./localizedInput.vue?vue&type=script&lang=ts"

import "./localizedInput.vue?vue&type=style&index=0&id=6300d236&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6300d236"]])

export default __exports__